// types.ts
export type LiteStarTheme = 'nanolite-secure' | 'gas-leakage';

export interface ThemeStyles {
  wrapper: string;
  card: string;
  accentBorder: string;
  badge: string;
  font: string;
}

export const LATEST_THEME_CONFIG: Record<LiteStarTheme, ThemeStyles> = {
  'nanolite-secure': {
    wrapper: "bg-[#090d16] text-slate-200 transition-all duration-1000",
    card: "bg-[#111827]/80 border border-slate-700/50 backdrop-blur-md shadow-[0_0_20px_rgba(0,0,0,0.3)]",
    accentBorder: "border-blue-500/30",
    badge: "bg-blue-500/10 border-blue-500/30 text-blue-400",
    font: "font-mono"
  },
  'gas-leakage': {
    wrapper: "bg-[#020604] text-emerald-100 transition-all duration-1000",
    card: "bg-black/90 border border-emerald-500/40 backdrop-blur-2xl shadow-[0_0_40px_rgba(16,185,129,0.15)] animate-pulse-slow",
    accentBorder: "border-emerald-500/50 shadow-[inset_0_0_20px_rgba(16,185,129,0.1)]",
    badge: "bg-emerald-500/20 border-emerald-500/50 text-emerald-400 animate-pulse",
    font: "font-mono tracking-wide"
  }
};